import React, { useRef, useState, useEffect } from 'react';
import './fintech-smart-solutions.css';

export const FintechSmartSolutions = ({ className = '', ...props }) => (
  <span className={`fss-brand-name ${className}`.trim()} {...props}>
    Fintech Smart Solutions
    <sup className="fss-tm">TM</sup>
  </span>
);

export const BrandLogo = ({ src, alt, className = '' }) => {
  const imgRef = useRef(null);
  const [tmStyle, setTmStyle] = useState({});

  useEffect(() => {
    const updateTmPosition = () => {
      const img = imgRef.current;
      if (!img?.offsetHeight || !img?.offsetWidth) return;

      const { offsetWidth: w, offsetHeight: h } = img;
      const size = Math.min(11, Math.max(8, Math.round(h * 0.1)));

      setTmStyle({
        fontSize: `${size}px`,
        top: `${Math.round(h * 0.79)}px`,
        left: `${Math.round(w * 0.915)}px`,
      });
    };

    const img = imgRef.current;
    if (!img) return;

    updateTmPosition();
    img.addEventListener('load', updateTmPosition);

    const observer = new ResizeObserver(updateTmPosition);
    observer.observe(img);

    return () => {
      img.removeEventListener('load', updateTmPosition);
      observer.disconnect();
    };
  }, [src]);

  return (
    <span className="fss-brand-logo-wrap">
      <span className="fss-brand-logo-inner">
        <img ref={imgRef} src={src} alt={alt} className={className} />
        <span className="fss-tm-logo" style={tmStyle}>TM</span>
      </span>
    </span>
  );
};

export default FintechSmartSolutions;
